const initialState = {
  reports: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_REPORTS_KEY':
      return {
        ...state,
        ...action.payload,
      };
    case 'CLEAR_REPORTS':
      return initialState;
    default:
      return state;
  }
};
